import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";
import AcademicModal from "models/academic.modal";
import Academicimage from "../../assets/img/academic.jpeg";
import academicModal from "models/academic.modal";

const SubjectAca = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const parmas = useParams();

  const getListData = async () => {
    setIsLoading(true);
    await AcademicModal.listbyidAcademicSubCategory(parmas?.id)

      .then((result) => {
        // console.log("here", result);
        setIsLoading(false);
        if (result) {
          setDataList(result?.data?.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getListData();
  }, [location, parmas?.id]);

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          AcademicModal.removeAcademic(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      });
  };
  const handleToggle = (id, value,name,title) => {
    const form = new FormData();
    form.append("name",name);
    form.append("title",title);
    form.append("id",id);
    form.append("vacancyavailable",value);
    form.append("logo","")
   
    academicModal.Editacademic(form)
    .then((responce)=>{
      
      helper.sweetalert.toast(responce?.data?.message, "success"); 
    })
    .catch((error)=>{
      console.log("error",error)
    })
  };
  const [searchQuery, setSearchQuery] = useState('');

  const filteredDataList = dataList?.filter((item) =>
    item?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  return (
    <>
      <div className="pt-7 px-4">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">All Subjects</h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                 <Input
        className="mr-4"
        type="text"
        placeholder="Search"
        size="sm"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
                  <Button
                    size="sm"
                    to={`/admin/academic/subject/${parmas.id}/${"subject"}`}
                    tag={Link}
                    style={{backgroundColor:"#080278",color:"white"}} 
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>

             <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">SN.</th>
            <th scope="col">Name</th>
            <th scope="col">Icon</th>
            <th scope="col">Vacancy</th>
            <th>Action</th>
          </tr>
        </thead>
        {!isLoading && (
          <tbody>
            {filteredDataList?.length > 0 ? (
              filteredDataList?.slice().reverse().map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>
                    <img src={item.logo} height="25px" alt={item.name} />
                  </td>
                  <td>
                    <label className="custom-toggle custom-toggle-danger">
                      <input
                        type="checkbox"
                        defaultChecked={item.vacancyavailable}
                        onChange={(e) =>
                          handleToggle(item.id, e.target.checked, item.name, item.title)
                        }
                      />
                      <span
                        className="custom-toggle-slider rounded-circle"
                        data-label-off="false"
                        data-label-on="true"
                      ></span>
                    </label>
                  </td>
                  <td className="p-0" style={{ display: "flex", flexDirection: "row" }}>
                    <UncontrolledTooltip placement="bottom" target="eyeTooltip">
                      Edit
                    </UncontrolledTooltip>
                    <Link
                      style={{
                        margin: "0 5px",
                        fontSize: "15px",
                        color: "blue",
                        display: "inline-block",
                        marginTop: "10px",
                        borderRadius: "30%",
                      }}
                      id="eyeTooltip"
                      to={`/admin/academic/editsubject/${item.id}/${parmas?.id}/${"subject"}`}
                    >
                      <i className="fa-solid fa-pen-to-square"></i>
                    </Link>

                    <UncontrolledTooltip placement="bottom" target="userTooltip">
                      Delete
                    </UncontrolledTooltip>
                    <p
                      style={{
                        cursor: "pointer",
                        margin: "0 8px",
                        fontSize: "15px",
                        color: "red",
                        marginTop: "10px",
                        display: "inline-block",
                        borderRadius: "20%",
                      }}
                      id="userTooltip"
                      onClick={() => handleDel(item.id)}
                    >
                      <i className="fas fa-trash"></i>
                    </p>
                  </td>
                </tr>
              ))
            ) : (
              <tr style={{ textAlign: "center" }}>
                <td colSpan="5" style={{ verticalAlign: "middle" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        )}
      </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};

export default SubjectAca;
